(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8276],{

/***/ 19806:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/history",
      function () {
        return __webpack_require__(68304);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_base_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10737);
/* harmony import */ var _hooks_use_nemo_wallet__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6200);
/* harmony import */ var _hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74069);






const ConnectWalletToContinue = ()=>{
    const trans = (0,_hooks_useTrans__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const { connectWallet  } = (0,_hooks_use_nemo_wallet__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        "data-testid": "connect-wallet-to-continue",
        className: "items-center justify-start my-4 h-screen",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: "items-center justify-center h-3/6 gap-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: "/connect_wallet.svg",
                    alt: "thanh-toan",
                    width: 161,
                    height: 0,
                    className: "w-[120px] h-auto sm:w-[161px]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    className: "items-center justify-center gap-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: "font-bold text-lg sm:text-2xl",
                            children: trans.common.connect_your_wallet_to_continue
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            onClick: connectWallet,
                            className: "w-[220px]",
                            size: "xl",
                            children: trans.common.connect_wallet
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConnectWalletToContinue);


/***/ }),

/***/ 68304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_common_ConnectWalletToContinue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8823);
/* harmony import */ var _hooks_use_nemo_wallet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6200);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72026);






const History = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>Promise.all(/* import() */[__webpack_require__.e(5092), __webpack_require__.e(783), __webpack_require__.e(4333)]).then(__webpack_require__.bind(__webpack_require__, 33872)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(33872)
            ]
    },
    ssr: false
});
const HistoryPage = ()=>{
    const { publicKey  } = (0,_hooks_use_nemo_wallet__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_5__/* .MainLayout */ .Z, {
        hasContainer: false,
        children: publicKey ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(History, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ConnectWalletToContinue__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HistoryPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,4430,9774,2888,179], function() { return __webpack_exec__(19806); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);